const SectionBreak = () => {
  return (
    <div
      className="w-full h-12"
      style={{
        background:
          "linear-gradient(180deg, hsl(var(--primary) / 0.06) 0%, transparent 100%)",
      }}
    />
  );
};

export default SectionBreak;
